module.exports = __webpack_public_path__ + "static/img/p8.41ad55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p8.png
// module id = mJYk
// module chunks = 0